import { Router } from "@angular/router";
import { NbMenuService } from "@nebular/theme";
import { AuthService } from "./pages/auth.service";
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from "@angular/core";
import { AnalyticsService } from "./@core/utils/analytics.service";
import { MenuPermissoesService } from './menuPermissoes.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: "ngx-app",
  template: "<router-outlet></router-outlet>"
})
export class AppComponent implements OnInit {
  constructor(
    private analytics: AnalyticsService,
    private auth: AuthService,
    private menuService: NbMenuService,
    private router: Router,
    private menuAdminService: MenuPermissoesService,
    private translate: TranslateService
  ) {
    translate.setDefaultLang('br');
  }

  ngOnInit(): void {
    this.menuService.onItemClick().subscribe(event => {
      if (event.item.title === "Logout") {
        this.menuService.collapseAll();
        this.auth.logout().then((response) => {
          window.location.href = response.toString();
          this.router.navigate(["/login"]);
          this.menuAdminService.reset();
        });
      }else if(event.item.title.toString() === "Alterar Senha"){
        this.router.navigate(["/change-password"]);
      }
    });
  }

  exibindo() {
    return this.router.url !== "/login";
  }
}
